import React from 'react';
import { FaTimes } from 'react-icons/fa';
import './TicketDetailsModal.css';

const TicketDetailsModal = ({ isVisible, onClose, ticketData }) => {
  if (!isVisible || !ticketData) return null;

  return (
    <div className="ticket-details-modal-overlay" onClick={onClose}>
      <div className="ticket-details-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ticket-details-modal-header">
          <h2>Ticket Details</h2>
          <button className="ticket-details-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="ticket-details-modal-content">
          <div className="ticket-details-section">
            <div className="ticket-details-item">
              <div className="ticket-details-label">
                <span>User Name</span>
              </div>
              <div className="ticket-details-value">
                {ticketData.user?.name || 'N/A'}
              </div>
            </div>

            <div className="ticket-details-item">
              <div className="ticket-details-label">
                <span>Subject</span>
              </div>
              <div className="ticket-details-value">
                {ticketData.subject || 'N/A'}
              </div>
            </div>

            <div className="ticket-details-item">
              <div className="ticket-details-label">
                <span>Description</span>
              </div>
              <div className="ticket-details-description-container">
                <div className="ticket-details-description">
                  {ticketData.description || 'No description provided'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketDetailsModal; 